export default "__VITE_ASSET__Br83Zkha__"